import React from "react";
import SimpleToggleButton from "../../../common/SimpleToggleButton/SimpleToggleButton";
import { useNavigate } from "react-router-dom";

const TenantCard = ({ tenant, onToggleActive, updatingTenantCode }) => {
  const { name, code, type, is_active } = tenant;

  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(`/issuer/tenant/${code}/organisations/users`);
  };

  return (
    <div
      className="flex flex-row items-center border rounded-[var(--cf-issued-credential-border-radius)] py-[var(--cf-issued-credential-template-card-padding-y)] px-6 hover:bg-[#F9FAFB] min-h-[5rem] min-w-[78.8rem] cursor-pointer"
      onClick={handleCardClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleCardClick();
        }
      }}
      role="button"
      tabIndex={0}
    >
      <div className="w-1/5 text-center min-w-[200px] flex-shrink-0 overflow-hidden">
        <p className="text-cfHeadingText whitespace-nowrap truncate">{name}</p>
      </div>
      <div className="w-1/5 text-center min-w-[150px] flex-shrink-0 overflow-hidden">
        <p className="text-cfHeadingText truncate">{code}</p>
      </div>
      <div className="w-1/5 text-center min-w-[150px] flex-shrink-0 overflow-hidden">
        <p className="text-cfHeadingText truncate">{type}</p>
      </div>
      <div className="w-1/5 text-center min-w-[120px] flex-shrink-0 overflow-hidden">
        <span
          className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${
            is_active
              ? "bg-cfIssuedCredentialTemplateCardStatusDoneBG text-cfIssuedCredentialTemplateCardStatusText"
              : "bg-cfIssuedCredentialTemplateCardStatusRevokedBG text-white"
          }`}
        >
          {is_active ? "Active" : "Inactive"}
        </span>
      </div>
      <div className="w-1/5 text-center min-w-[120px] flex-shrink-0 overflow-hidden">
        <div className="relative inline-flex items-center cursor-pointer">
          <SimpleToggleButton
            checked={is_active}
            onChange={() => onToggleActive(tenant)}
            disabled={updatingTenantCode === code}
          />
        </div>
      </div>
    </div>
  );
};

export default TenantCard;
